<ng-container *ngIf="loading">
    <div class="loading-bar">
        <tm1-progress-ring value="" min="0" max="1" size="regular" ></tm1-progress-ring>
</div>
</ng-container>

<tm1-button (click)=feedDisplay() style="margin-top: 10px;">Back</tm1-button>
<tm1-card variant = "shadow" class="section">
    <form>
        <tm1-typography type="title-page">Add Feed</tm1-typography>
        <fieldset>
            <tm1-select (change)='addFeedTypeChangeHandler($event)' label="Delvery Type"
                placeholder="Select" style="width: 15%; margin-left: 42.5%; margin-top: 2%;">
                <ng-container *ngFor="let key of venue.objectKeys(deliveryOptions.methods)">
                    <tm1-option
                        value="{{deliveryOptions.methods[key].typeName}}">{{deliveryOptions.methods[key].typeName}}</tm1-option>
                </ng-container>
            </tm1-select>
            <ng-container *ngIf="addFeedType">
                <tm1-text-field (change)="getDeliveryNameValue($event)" class="textField"
                    appearance="outline" inputsize="regular" label="Delivery Name"
                    type="text"></tm1-text-field>
                <ng-container [ngSwitch]="addFeedType">
                    <ng-container *ngSwitchCase="'S3'">
                        <tm1-text-field (change)="getBucketValue($event)" class="textField"
                            appearance="outline" inputsize="regular" label="Bucket"
                            type="text"></tm1-text-field>
                            <tm1-text-field
                            ngDefaultControl
                            (change) = "getDsnValue($event)"
                            [(ngModel)]="dsnInput"
                            (keydown.enter)="getDsnValue($event); addDsn($event)"
                            placeholder="Enter DSN and press Enter"
                            label="DSNs"
                            inputsize="regular"
                            appearance="outline"
                            ></tm1-text-field>

                            <div class="chip" *ngFor="let dsn of dsnList; let i = index">
                            {{ dsn }}
                            <span class="close-btn" (click)="removeDsn(i)">&times;</span>
                            </div>


                        <tm1-text-area
                          label="Send dates"    
                          supportingText="Dates must be YYYY-MM-DD format"
                          type="textarea"
                          (change) = getDates($event)
                          placeholder="Enter Dates with each date on a new line"
                        ></tm1-text-area>
                        <ng-container *ngFor="let dateKey of venue.objectKeys(sendDates)">
                          <div class="chip">
                            <span>
                              {{ dateKey }}<ng-container *ngIf="isTimeRange(sendDates[dateKey])"> ({{ formatTimeRange(sendDates[dateKey]) }})</ng-container>
                            </span>
                            <span (click)="startEditTimes(dateKey, sendDates[dateKey])" class="edit-btn" title="Edit times">&#9998;</span>
                            <span class="close-btn" (click)="removeChip(dateKey)">&times;</span>
                          </div>
                          <div class="chip-editor" *ngIf="isEditingTimes(dateKey)">
                            <div class="time-range-row">
                              <label>
                                Start
                                <input type="time" [(ngModel)]="editStart" [ngModelOptions]="{standalone: true}" />
                              </label>
                              <label>
                                End
                                <input type="time" [(ngModel)]="editEnd" [ngModelOptions]="{standalone: true}" />
                              </label>
                            </div>
                            <div class="time-range-row">
                              <tm1-button color="positive" (click)="saveEditTimes(dateKey)">Save</tm1-button>
                              <tm1-button (click)="clearChipTimes(dateKey)">Clear Times</tm1-button>
                              <tm1-button (click)="cancelEditTimes()">Cancel</tm1-button>
                            </div>
                          </div>
                        </ng-container>
                            <br/>
                        <tm1-button
                          style=" margin-top: 10px;"
                          class="addButton"
                          color="positive"
                          (click)="addDate($event)">Add Dates</tm1-button>
                            <br/>
                        <tm1-button style=" margin-top: 10px;" (click)="addFeed('S3')">Add Feed</tm1-button>
                    </ng-container>
                    <ng-container *ngSwitchCase="'SFTP'">
                        <tm1-text-field (change)="getPathValue($event)" class="textField"
                            appearance="outline" inputsize="regular" label="Path"
                            type="text"></tm1-text-field>
                        <tm1-text-field (change)="getServerValue($event)" class="textField"
                            appearance="outline" inputsize="regular" label="Server"
                            type="text"></tm1-text-field>
                        <tm1-text-field (change)="getUsernameValue($event)" class="textField"
                            appearance="outline" inputsize="regular" label="Username"
                            type="text"></tm1-text-field>
                        <tm1-text-field (change)="getPasswordValue($event)" class="textField"
                            appearance="outline" inputsize="regular" label="Password"
                            type="text"></tm1-text-field>
                            <tm1-text-field
                            ngDefaultControl
                            (change) = "getDsnValue($event)"
                            [(ngModel)]="dsnInput"
                            (keydown.enter)="getDsnValue($event); addDsn($event)"
                            placeholder="Enter DSN and press Enter"
                            label="DSNs"
                            inputsize="regular"
                            appearance="outline"
                            ></tm1-text-field>

                            <div class="chip" *ngFor="let dsn of dsnList; let i = index">
                            {{ dsn }}
                            <span class="close-btn" (click)="removeDsn(i)">&times;</span>
                            </div>


                        <tm1-text-area
                          label="Send dates"    
                          supportingText="Dates must be YYYY-MM-DD format"
                          type="textarea"
                          (change) = getDates($event)
                          placeholder="Enter Dates with each date on a new line"
                        ></tm1-text-area>
                        <ng-container *ngFor="let dateKey of venue.objectKeys(sendDates)">
                          <div class="chip">
                            <span>
                              {{ dateKey }}<ng-container *ngIf="isTimeRange(sendDates[dateKey])"> ({{ formatTimeRange(sendDates[dateKey]) }})</ng-container>
                            </span>
                            <span (click)="startEditTimes(dateKey, sendDates[dateKey])" class="edit-btn" title="Edit times">&#9998;</span>
                            <span class="close-btn" (click)="removeChip(dateKey)">&times;</span>
                          </div>
                          <div class="chip-editor" *ngIf="isEditingTimes(dateKey)">
                            <div class="time-range-row">
                              <label>
                                Start
                                <input type="time" [(ngModel)]="editStart" [ngModelOptions]="{standalone: true}" />
                              </label>
                              <label>
                                End
                                <input type="time" [(ngModel)]="editEnd" [ngModelOptions]="{standalone: true}" />
                              </label>
                            </div>
                            <div class="time-range-row">
                              <tm1-button color="positive" (click)="saveEditTimes(dateKey)">Save</tm1-button>
                              <tm1-button (click)="clearChipTimes(dateKey)">Clear Times</tm1-button>
                              <tm1-button (click)="cancelEditTimes()">Cancel</tm1-button>
                            </div>
                          </div>
                        </ng-container>
                            <br/>
                        <tm1-button
                          style=" margin-top: 10px;"
                          class="addButton"
                          color="positive"
                          (click)="addDate($event)">Add Dates</tm1-button>
                            <br/>
                        <tm1-button style=" margin-top: 10px;" class="addButton" (click)="addFeed('SFTP')">Add Feed</tm1-button>

                    </ng-container>




                    <ng-container *ngSwitchCase="'AZURE'">
                        <tm1-text-field (change)="getURLValue($event)" class="textField"
                            appearance="outline" inputsize="regular" label="Share Access URL"
                            type="text"></tm1-text-field>

                            <tm1-text-field
                            ngDefaultControl
                            (change) = "getDsnValue($event)"
                            [(ngModel)]="dsnInput"
                            (keydown.enter)="getDsnValue($event); addDsn($event)"
                            placeholder="Enter DSN and press Enter"
                            label="DSNs"
                            inputsize="regular"
                            appearance="outline"
                            ></tm1-text-field>

                            <div class="chip" *ngFor="let dsn of dsnList; let i = index">
                            {{ dsn }}
                            <span class="close-btn" (click)="removeDsn(i)">&times;</span>
                            </div>


                        <tm1-text-area
                          label="Send dates"    
                          supportingText="Dates must be YYYY-MM-DD format"
                          type="textarea"
                          (change) = getDates($event)
                          placeholder="Enter Dates with each date on a new line"
                        ></tm1-text-area>
                        <ng-container *ngFor="let dateKey of venue.objectKeys(sendDates)">
                          <div class="chip">
                            <span>
                              {{ dateKey }}<ng-container *ngIf="isTimeRange(sendDates[dateKey])"> ({{ formatTimeRange(sendDates[dateKey]) }})</ng-container>
                            </span>
                            <span (click)="startEditTimes(dateKey, sendDates[dateKey])" class="edit-btn" title="Edit times">&#9998;</span>
                            <span class="close-btn" (click)="removeChip(dateKey)">&times;</span>
                          </div>
                          <div class="chip-editor" *ngIf="isEditingTimes(dateKey)">
                            <div class="time-range-row">
                              <label>
                                Start
                                <input type="time" [(ngModel)]="editStart" [ngModelOptions]="{standalone: true}" />
                              </label>
                              <label>
                                End
                                <input type="time" [(ngModel)]="editEnd" [ngModelOptions]="{standalone: true}" />
                              </label>
                            </div>
                            <div class="time-range-row">
                              <tm1-button color="positive" (click)="saveEditTimes(dateKey)">Save</tm1-button>
                              <tm1-button (click)="clearChipTimes(dateKey)">Clear Times</tm1-button>
                              <tm1-button (click)="cancelEditTimes()">Cancel</tm1-button>
                            </div>
                          </div>
                        </ng-container>
                            <br/>
                        <tm1-button
                          style=" margin-top: 10px;"
                          class="addButton"
                          color="positive"
                          (click)="addDate($event)">Add Dates</tm1-button>
                          <br/>
                        <tm1-button style=" margin-top: 10px; " class="addButton" (click)="addFeed('Azure')">Add Feed</tm1-button>
                    </ng-container>
                    <ng-container *ngSwitchCase="'KINESIS'">
                        <tm1-text-field (change)="getEventBUSValue($event)" class="textField"
                            appearance="outline" inputsize="regular" label="Event BUS"
                            type="text"></tm1-text-field>
                            <tm1-text-field (change)="getStreamValue($event)" class="textField"
                            appearance="outline" inputsize="regular" label="Stream"
                            type="text"></tm1-text-field>
                            <tm1-text-field
                            ngDefaultControl
                            (change) = "getDsnValue($event)"
                            [(ngModel)]="dsnInput"
                            (keydown.enter)="getDsnValue($event); addDsn($event)"
                            placeholder="Enter DSN and press Enter"
                            label="DSNs"
                            inputsize="regular"
                            appearance="outline"
                            ></tm1-text-field>

                            <div class="chip" *ngFor="let dsn of dsnList; let i = index">
                            {{ dsn }}
                            <span class="close-btn" (click)="removeDsn(i)">&times;</span>
                            </div>
                        <tm1-text-area
                          label="Send dates"    
                          supportingText="Dates must be YYYY-MM-DD format"
                          type="textarea"
                          (change) = getDates($event)
                          placeholder="Enter Dates with each date on a new line"
                        ></tm1-text-area>
                        <ng-container *ngFor="let dateKey of venue.objectKeys(sendDates)">
                          <div class="chip">
                            <span>
                              {{ dateKey }}<ng-container *ngIf="isTimeRange(sendDates[dateKey])"> ({{ formatTimeRange(sendDates[dateKey]) }})</ng-container>
                            </span>
                            <span (click)="startEditTimes(dateKey, sendDates[dateKey])" class="edit-btn" title="Edit times">&#9998;</span>
                            <span class="close-btn" (click)="removeChip(dateKey)">&times;</span>
                          </div>
                          <div class="chip-editor" *ngIf="isEditingTimes(dateKey)">
                            <div class="time-range-row">
                              <label>
                                Start
                                <input type="time" [(ngModel)]="editStart" [ngModelOptions]="{standalone: true}" />
                              </label>
                              <label>
                                End
                                <input type="time" [(ngModel)]="editEnd" [ngModelOptions]="{standalone: true}" />
                              </label>
                            </div>
                            <div class="time-range-row">
                              <tm1-button color="positive" (click)="saveEditTimes(dateKey)">Save</tm1-button>
                              <tm1-button (click)="clearChipTimes(dateKey)">Clear Times</tm1-button>
                              <tm1-button (click)="cancelEditTimes()">Cancel</tm1-button>
                            </div>
                          </div>
                        </ng-container>
                            <br/>
                        <tm1-button
                          style=" margin-top: 10px;"
                          class="addButton"
                          color="positive"
                          (click)="addDate($event)">Add Dates</tm1-button>
                            <br/>
                            <tm1-button style=" margin-top: 10px;" (click)="addFeed('Kinesis')">Add Feed</tm1-button>
                    </ng-container>
                </ng-container>
            </ng-container>
        </fieldset>
    </form>
</tm1-card>
